module.exports = __webpack_public_path__ + "static/media/gold-card.d367c85c.png";